"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewObserverPreset = exports.buildThreshold = void 0;
/**
 * Build an array of threshold values ranging from 0 to 1
 * @param {Number} steps - number of steps between 0 and 1.0
 * @returns {Number[]} returns array of floats
 */
const buildThreshold = (steps = 1) => {
    const threshold = Array.from({ length: steps }, (_x, i) => i / steps);
    // Returns an array like [0, ...n, 1]
    return [...threshold, 1];
};
exports.buildThreshold = buildThreshold;
exports.ViewObserverPreset = {
    default: {
        scene: 'default',
        root: null,
        rootMargin: '',
        threshold: (0, exports.buildThreshold)(10),
        targetVisibleIntersectionThreshold: 0.8,
        containerVisibleIntersectionThreshold: 0.5,
        minTimeVisible: 250,
    },
    'viewport-asap': {
        scene: 'viewport-asap',
        root: null,
        rootMargin: '',
        threshold: (0, exports.buildThreshold)(1),
        targetVisibleIntersectionThreshold: 0,
        containerVisibleIntersectionThreshold: 0,
        minTimeVisible: 0,
    },
};
